<template>
  <ul v-if='errors.length' class='errors-messages'>
    <li v-for='error in errors'>
      {{ $t(`errors.${error}`) }}
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'errors-messages',
    props: {
      errors: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .errors-messages {
    color: $color-red;
    margin-bottom: $space-medium;
  }
</style>
